/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class SimpleDate extends BaseField {

    protected opts: SimpleDateOptions;

    private inputForUser: JQuery;

    constructor (element: string | JQuery, opts: ObjectHash = {}) {

        super(element, opts);

        this.inputForUser = this.element.find('input[type="text"]');

        let datePickerOptions: JQueryUI.DatepickerOptions = {
            'dateFormat': 'D, d M yy',
        };

        datePickerOptions = $.extend({}, MACRAIL.defaultDatePickerOptions, datePickerOptions);

        this.inputForUser.datepicker(datePickerOptions);

        // this.element.on('change', () => {
        //     this.recalculate();
        // });

        /*this.element.on('keyup', () => {
            this.recalculate();
        });*/

        // setInterval(() => {
        //     // Don't mess around when the user is still focused there.
        //     if (this.inputForUser.is(':focus')) {
        //         return;
        //     }
        //     this.recalculate();
        // }, 60000);
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        if (enabled) {
            this.inputForUser
                .prop('disabled', false)
                .removeClass('disabled');
        } else {
            this.inputForUser
                .prop('disabled', true)
                .addClass('disabled');
        }
    }

    public setValue(newValue: any) {
        // If a Date object was supplied, set date picker.
        if (newValue && newValue.getFullYear) {
            this.inputForUser.datepicker('setDate', newValue);
        }

        // this.inputForUser.val(newValue);
        // this.setDirty(true);
    }

    public getValue() {
        if (!this.inputForUser) {
            return undefined;
        }
        return this.inputForUser.datepicker('getDate');
    }
}

interface SimpleDateOptions extends FieldOptions {
    format: string;
}

}
